import { displayStringFromFHIRCodeableConcept, simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import { displayStringFromFHIRRange } from "../../datatypeComponents/RangeEntry";
import { displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";

const generateNarrativeForEvidenceVariableResource = (resource) => {
    let status = "generated";
    let innerDiv = "";
    try {
        if (resource.title) {
            innerDiv += "<p><b>Title: </b>" + resource.title + "</p>";
        }
        if (resource.shortTitle) {
            innerDiv += "<p><b>Short title: </b>" + resource.shortTitle + "</p>";
        }
        if (resource.name) {
            innerDiv += "<p><b>Name: </b>" + resource.name + "</p>";
        }
        if (resource.description) {
            innerDiv += "<p><b>Description: </b>" + resource.description + "</p>";
        }
        if (resource.note?.length > 0) {
            innerDiv += resource.note.map((note) => {
                return "<p><b>Note: </b>" + note.text + "</p>"
            }).join("");
        }
        if (resource.definition?.concept) {
            innerDiv += "<p><b>Definition: </b>" + displayStringFromFHIRCodeableConcept(resource.definition.concept) + "</p>";
        }
        if (resource.definition?.reference) {
            innerDiv += "<p><b>Definition: </b>" + displayStringFromFHIRReference(resource.definition.reference) + "</p>";
        }
        if (resource.handling) {
            let handlingDisplay = "";
            if (typeof resource.handling === "object") {
                handlingDisplay = simpleDisplayStringFromFHIRCodeableConcept(resource.handling);
            } else if (typeof resource.hadnling === "string") {
                handlingDisplay = resource.handling;
            }
            innerDiv += "<p><b>Handling: </b>" + handlingDisplay + "</p>";
        }
        if (resource.category?.length > 0) {
            innerDiv += resource.category.map((item) => {
                let categoryName = item.name || "";
                let categoryValue = "";
                if (item.valueCodeableConcept) {
                    categoryValue = displayStringFromFHIRCodeableConcept(item.valueCodeableConcept);
                } else if (item.valueQuantity) {
                    categoryValue = displayStringFromFHIRQuantity(item.valueQuantity);
                } else if (item.valueRange) {
                    categoryValue = displayStringFromFHIRRange(item.valueRange);
                } else if (item.valueReference) {
                    categoryValue = displayStringFromFHIRReference(item.valueReference);
                }
                if (categoryName && categoryValue) {
                    return "<p><b>Category " + categoryName + ": </b>" + categoryValue + "</p>"
                } else if (categoryName) {
                    return "<p><b>Category: </b>" + categoryName + "</p>"
                } else if (categoryValue) {
                    return "<p><b>Category: </b>" + categoryValue + "</p>"
                } else {
                    return ""
                }
            }).join("");
        }
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return { "status": status, "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">" + innerDiv + "</div>" };
}

export default generateNarrativeForEvidenceVariableResource;